var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
export class ArrayUtil {
    static randomItem(array) {
        return array[Math.floor(Math.random() * array.length)];
    }
    static filterUndefined(array) {
        return array.filter(i => i !== undefined);
    }
    static clear(array) {
        array.splice(0, array.length);
    }
    static fromIterator(iterator) {
        var _a, iterator_1, iterator_1_1;
        var _b, e_1, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            const result = [];
            try {
                for (_a = true, iterator_1 = __asyncValues(iterator); iterator_1_1 = yield iterator_1.next(), _b = iterator_1_1.done, !_b;) {
                    _d = iterator_1_1.value;
                    _a = false;
                    try {
                        const item = _d;
                        result.push(item);
                    }
                    finally {
                        _a = true;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (!_a && !_b && (_c = iterator_1.return)) yield _c.call(iterator_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return result;
        });
    }
    static difference(arr1, arr2) {
        return arr1.filter(x => !arr2.includes(x));
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXJyYXlVdGlsLmpzIiwic291cmNlUm9vdCI6InNyYy8iLCJzb3VyY2VzIjpbInV0aWwvYXJyYXlVdGlsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSxNQUFNLE9BQU8sU0FBUztJQUNwQixNQUFNLENBQUMsVUFBVSxDQUFLLEtBQVU7UUFDOUIsT0FBTyxLQUFLLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsTUFBTSxFQUFFLEdBQUcsS0FBSyxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUE7SUFDeEQsQ0FBQztJQUVELE1BQU0sQ0FBQyxlQUFlLENBQUssS0FBMkI7UUFDcEQsT0FBTyxLQUFLLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxLQUFLLFNBQVMsQ0FBUSxDQUFBO0lBQ2xELENBQUM7SUFFRCxNQUFNLENBQUMsS0FBSyxDQUFLLEtBQVU7UUFDekIsS0FBSyxDQUFDLE1BQU0sQ0FBQyxDQUFDLEVBQUUsS0FBSyxDQUFDLE1BQU0sQ0FBQyxDQUFBO0lBQy9CLENBQUM7SUFFRCxNQUFNLENBQU8sWUFBWSxDQUFLLFFBQWtDOzs7O1lBQzlELE1BQU0sTUFBTSxHQUFHLEVBQUUsQ0FBQTs7Z0JBQ2pCLGdCQUF5QixhQUFBLGNBQUEsUUFBUSxDQUFBO29CQUFSLHdCQUFRO29CQUFSLFdBQVE7O3dCQUF0QixNQUFNLElBQUksS0FBQSxDQUFBO3dCQUFnQixNQUFNLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFBOzs7OztpQkFBRTs7Ozs7Ozs7O1lBQ3hELE9BQU8sTUFBTSxDQUFBOztLQUNkO0lBRUQsTUFBTSxDQUFDLFVBQVUsQ0FBSyxJQUFTLEVBQUUsSUFBUztRQUN4QyxPQUFPLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLElBQUksQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQTtJQUM1QyxDQUFDO0NBQ0YifQ==